<template>
  <label for="employees-multiselect-component" class="form-label">
    {{ $t('employee.list') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedEmployees"
    :options="{
      create: false,
      placeholder: $t('employee.selectMore')
    }"
    class="w-full"
    multiple
  >
    <option
      v-for="employee in employees"
      :value="employee.uuid"
      :key="employee.uuid"
    >
      {{ employee.name }} {{ employee.lastname }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import employeeApi from '../../services/employees/employee.api'

export default defineComponent({
  data() {
    return {
      employees: []
    }
  },
  mounted() {
    employeeApi.getList(1, 100).then(
      response => {
        this.employees = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedEmployees: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedEmployees'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedEmployees,
      set: value => emit('update:selectedEmployees', value)
    })

    return {
      componentValue
    }
  }
})
</script>
